import React from "react";
import { Container } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import { Col } from "react-bootstrap";
function Services() {
  
  return (
    <>
      <Container fluid>
        <Row className="headingimgnew">
          <Col className="m-5">
            <h1 className="text-white m-4 mx-4 px-2 fw-bold text-center">
              Services
            </h1>
            <div className="text-white m-4 fw-bold text-center">
              <a href="/" className=" text-white m-3 text-decoration-none">
                Home
              </a>
              <i class="fa-solid fa-circle-arrow-right fa-beat"></i>
              <a className="text-white text-decoration-none m-3">Services</a>
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <h2>Services Page</h2>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Services;
